import { getNativeState } from './nativePermissions';

/**
 * Whether this phone may stop InGo in the background, and what to tell the
 * rider (the mobile plan's M6, sequence D: Tecno, Infinix, itel, Xiaomi and
 * Samsung put a backgrounded app to sleep, and with it the position and the
 * offers). Asked at the moment the rider asks for background work, going
 * online, as Kangaru's `batteryPrompt.ts` does, never at launch.
 *
 * Tri-state on purpose: only an explicit "optimised" from the phone asks;
 * a phone that could not be asked (the web, an old build) is never nagged.
 *
 * @param {() => Promise<{ batteryOptimised?: boolean, manufacturer?: string } | null>} [readNative]
 * @returns {Promise<string | null>} the sentence to show, or null when there is nothing to ask
 */
export async function batteryAsk(readNative = getNativeState) {
  let state = null;
  try {
    state = await readNative();
  } catch {
    return null;
  }
  if (!state || state.batteryOptimised !== true) return null;

  return batterySentence(state.manufacturer);
}

/** The one sentence for this maker: Android's own setting, and the maker's extra one where it has one. */
export function batterySentence(manufacturer) {
  const base = 'Your phone may stop InGo when it is in the background, and then offers and your position stop too. Set InGo\'s battery use to Unrestricted';
  const maker = String(manufacturer || '').toLowerCase();
  if (/xiaomi|redmi|poco/.test(maker)) return `${base}, and turn on Autostart for InGo (Security, Permissions).`;
  if (/tecno|infinix|itel|transsion/.test(maker)) return `${base}, and allow InGo to auto-start in Phone Master.`;
  if (/samsung/.test(maker)) return `${base}, and keep InGo out of Sleeping apps (Battery, Background usage limits).`;
  if (/huawei|honor/.test(maker)) return `${base}, and set InGo's App launch to Manage manually.`;
  if (/oppo|realme|oneplus|vivo/.test(maker)) return `${base}, and allow InGo's background activity and Auto launch.`;

  return `${base}.`;
}
